import styled, { css } from 'styled-components';

import { media } from '../../../../../constants/src/shared/media';

interface DropzoneProps {
  $isDragActive: boolean;
}

export const $FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${media.minWidth.sm} {
    flex-direction: row;
  }
  justify-content: space-between;
  border: 1px solid ${(props) => props.theme.newUI.dividerColors.default};
  padding: 24px;
  border-radius: 8px;
`;

export const $FileInputLabelContainer = styled.div`
  flex: 1;
  padding-bottom: 24px;
  [class*='Labelstyles'] span {
    font-size: 14px;
    line-height: 19px;
    color: ${({ theme }) => theme.systemColors.defaultTextColor};
    font-weight: ${({ theme }) => theme.fonts.weight.mediumFont};
    height: unset;
    margin: unset;
  }
  [class*='LabelWrap'] {
    height: unset;
  }
  label {
    height: unset;
  }
  @media ${media.minWidth.sm} {
    padding-right: 24px;
    padding-bottom: unset;
  }
`;

export const $FileInputDropZoneContainer = styled.div<{
  $shouldExpand: boolean;
}>`
  width: 100%;

  ${({ $shouldExpand }) =>
    $shouldExpand
      ? css`
          border-top: 1px solid
            ${(props) => props.theme.newUI.dividerColors.default};

          @media ${media.minWidth.sm} {
            border-top: unset;
            border-left: 1px solid
              ${(props) => props.theme.newUI.dividerColors.default};
            width: 223px;
          }
        `
      : undefined}
`;

export const $Didactics = styled.div`
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  line-height: 1rem;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 24px;
`;

export const $FileInput = styled.input`
  display: none;
`;

export const $Dropzone = styled.button<DropzoneProps>`
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  background: transparent;
  border: none;
  padding-top: 24px;
  transition-duration: 0.3s;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};

  span:last-child {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    cursor: pointer;
  }

  @media ${media.minWidth.sm} {
    padding-top: unset;
    padding-left: 24px;
    padding-right: unset;
  }

  & div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const $MinimalWrapper = styled.div`
  display: flex;
  gap: 2rem;

  &&& {
    flex-direction: row;
  }
`;
